import { Scene } from 'phaser';
import { ASSET_MANIFEST, FONT_MANIFEST, FONTES_CSS } from '../data/assetManifest';
import { BOSS_FINAL_DEMO_INSIGHTS } from '../data/bossFinalDemoData';
import { GAME, SCENES } from '../config/constants';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { Sessao } from '../services/Sessao';

const BAR_WIDTH = 460;
const BAR_HEIGHT = 26;

export class Preloader extends Scene {
    constructor () {
        super(SCENES.PRELOADER);
    }

    init () {
        this.createProgressBar();
    }

    createProgressBar () {
        const { CENTER_X, CENTER_Y } = GAME;

        this.add.text(CENTER_X, CENTER_Y - 60, 'CARREGANDO', { ...ARCADE_TEXT.atalho, fontSize: '20px' })
            .setOrigin(0.5);

        this.add.rectangle(CENTER_X, CENTER_Y, BAR_WIDTH, BAR_HEIGHT)
            .setStrokeStyle(2, ARCADE_HEX.BRANCO);

        const fill = this.add.rectangle(
            CENTER_X - BAR_WIDTH / 2 + 4,
            CENTER_Y,
            4,
            BAR_HEIGHT - 8,
            ARCADE_HEX.LIMA
        ).setOrigin(0, 0.5);

        const percent = this.add.text(CENTER_X, CENTER_Y + 40, '0%', { ...ARCADE_TEXT.atalho, color: '#ffffff' })
            .setOrigin(0.5);

        this.load.on('progress', (value) => {
            fill.width = (BAR_WIDTH - 8) * value;
            percent.setText(`${Math.round(value * 100)}%`);
        });

        this.load.on('loaderror', (file) => {
            console.error(`[Preloader] falha ao carregar "${file.key}" (${file.src})`);
        });
    }

    preload () {
        this.load.setPath('assets');

        ASSET_MANIFEST.forEach(({ type, key, file, opts }) => {
            if (typeof this.load[type] !== 'function') {
                console.warn(`[Preloader] tipo de asset desconhecido: "${type}" (${key})`);
                return;
            }
            this.load[type](key, file, opts);
        });

        FONT_MANIFEST.forEach(({ key, file }) => this.load.font(key, file));
    }

    async create () {
        // O canvas mede texto na criação: sem a fonte pronta, o primeiro
        // quadro sairia na fonte de fallback e com largura errada.
        try {
            await Promise.all(FONTES_CSS.map((fonte) => document.fonts.load(fonte)));
        } catch (erro) {
            console.warn('[Preloader] fonte não carregada, seguindo com fallback.', erro);
        }

        // Demonstração do Boss Final, só em DEV: `?scene=boss-final[&seek=ms][&empty=1]`.
        const params = new URLSearchParams(window.location.search);
        if (import.meta.env.DEV && params.get('scene') === 'boss-final') {
            const requestedSeek = Number(params.get('seek') ?? 0);
            const seekMs = Number.isFinite(requestedSeek) ? Math.max(0, requestedSeek) : 0;
            this.scene.start(SCENES.BOSS_FINAL, {
                insights: params.get('empty') === '1' ? [] : BOSS_FINAL_DEMO_INSIGHTS,
                seekMs
            });
            return;
        }

        // Build do facilitador: quem decide a primeira tela é a própria estação.
        const entrada = this.registry.get('entrada');
        if (entrada) {
            this.scene.start(entrada());
            return;
        }

        // RN-CRE-04: vínculo salvo pula o login.
        this.scene.start(Sessao.ativa ? SCENES.AGUARDE : SCENES.LOGIN);
    }
}
